/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SupplierOwnInformationDiscountGroupsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  supplierId: Types.Scalars['ID']['input'];
}>;


export type SupplierOwnInformationDiscountGroupsQuery = { pimGetSupplierDiscountGroups: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimGetSupplierDiscountGroupsResult', totalCount: number, discountGroups: Array<{ __typename: 'PimDiscountGroup', id: string, description: string, discountType: Types.PimDiscountGroupDiscountType, key: string, value: number }> } };

export type SupplierOwnInformationDiscountGroupsVariantQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  supplierDiscountGroupVariantId: Types.Scalars['ID']['input'];
}>;


export type SupplierOwnInformationDiscountGroupsVariantQuery = { pimGetSupplierDiscountGroups: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimGetSupplierDiscountGroupsResult', totalCount: number, discountGroups: Array<{ __typename: 'PimDiscountGroup', id: string, description: string, discountType: Types.PimDiscountGroupDiscountType, key: string, value: number }> } };

export type SupplierOwnInformationDiscountGroupVariantsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  supplierId: Types.Scalars['ID']['input'];
}>;


export type SupplierOwnInformationDiscountGroupVariantsQuery = { pimSearchSupplierDiscountGroupVariants: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchSupplierDiscountGroupVariantsResult', totalCount: number, supplierDiscountGroupVariants: Array<{ __typename: 'PimSupplierDiscountGroupVariant', id: string, title: string }> } };

export type PimModifySupplierDiscountGroupMutationVariables = Types.Exact<{
  input: Types.PimModifySupplierDiscountGroupInput;
}>;


export type PimModifySupplierDiscountGroupMutation = { pimModifySupplierDiscountGroup: { __typename: 'PimModifySupplierDiscountGroupResult', discountGroup: { __typename: 'PimDiscountGroup', id: string, description: string, discountType: Types.PimDiscountGroupDiscountType, key: string, value: number } } };

export type DiscountGroupFragment = { __typename: 'PimDiscountGroup', id: string, description: string, discountType: Types.PimDiscountGroupDiscountType, key: string, value: number };

export const DiscountGroupFragmentDoc = gql`
    fragment DiscountGroup on PimDiscountGroup {
  id
  description
  discountType
  key
  value
}
    `;
export const SupplierOwnInformationDiscountGroupsDocument = gql`
    query SupplierOwnInformationDiscountGroups($limit: Int!, $offset: Int!, $supplierId: ID!) {
  pimGetSupplierDiscountGroups(
    limit: $limit
    offset: $offset
    filters: {supplierIds: [$supplierId]}
  ) {
    ... on PimGetSupplierDiscountGroupsResult {
      discountGroups {
        id
        ...DiscountGroup
      }
      totalCount
    }
  }
}
    ${DiscountGroupFragmentDoc}`;

/**
 * __useSupplierOwnInformationDiscountGroupsQuery__
 *
 * To run a query within a React component, call `useSupplierOwnInformationDiscountGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierOwnInformationDiscountGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierOwnInformationDiscountGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierOwnInformationDiscountGroupsQuery(baseOptions: Apollo.QueryHookOptions<SupplierOwnInformationDiscountGroupsQuery, SupplierOwnInformationDiscountGroupsQueryVariables> & ({ variables: SupplierOwnInformationDiscountGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierOwnInformationDiscountGroupsQuery, SupplierOwnInformationDiscountGroupsQueryVariables>(SupplierOwnInformationDiscountGroupsDocument, options);
      }
export function useSupplierOwnInformationDiscountGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierOwnInformationDiscountGroupsQuery, SupplierOwnInformationDiscountGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierOwnInformationDiscountGroupsQuery, SupplierOwnInformationDiscountGroupsQueryVariables>(SupplierOwnInformationDiscountGroupsDocument, options);
        }
export function useSupplierOwnInformationDiscountGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierOwnInformationDiscountGroupsQuery, SupplierOwnInformationDiscountGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierOwnInformationDiscountGroupsQuery, SupplierOwnInformationDiscountGroupsQueryVariables>(SupplierOwnInformationDiscountGroupsDocument, options);
        }
export type SupplierOwnInformationDiscountGroupsQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupsQuery>;
export type SupplierOwnInformationDiscountGroupsLazyQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupsLazyQuery>;
export type SupplierOwnInformationDiscountGroupsSuspenseQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupsSuspenseQuery>;
export type SupplierOwnInformationDiscountGroupsQueryResult = Apollo.QueryResult<SupplierOwnInformationDiscountGroupsQuery, SupplierOwnInformationDiscountGroupsQueryVariables>;
export const SupplierOwnInformationDiscountGroupsVariantDocument = gql`
    query SupplierOwnInformationDiscountGroupsVariant($limit: Int!, $offset: Int!, $supplierDiscountGroupVariantId: ID!) {
  pimGetSupplierDiscountGroups(
    limit: $limit
    offset: $offset
    filters: {supplierDiscountGroupVariantIds: [$supplierDiscountGroupVariantId]}
  ) {
    ... on PimGetSupplierDiscountGroupsResult {
      discountGroups {
        id
        ...DiscountGroup
      }
      totalCount
    }
  }
}
    ${DiscountGroupFragmentDoc}`;

/**
 * __useSupplierOwnInformationDiscountGroupsVariantQuery__
 *
 * To run a query within a React component, call `useSupplierOwnInformationDiscountGroupsVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierOwnInformationDiscountGroupsVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierOwnInformationDiscountGroupsVariantQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      supplierDiscountGroupVariantId: // value for 'supplierDiscountGroupVariantId'
 *   },
 * });
 */
export function useSupplierOwnInformationDiscountGroupsVariantQuery(baseOptions: Apollo.QueryHookOptions<SupplierOwnInformationDiscountGroupsVariantQuery, SupplierOwnInformationDiscountGroupsVariantQueryVariables> & ({ variables: SupplierOwnInformationDiscountGroupsVariantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierOwnInformationDiscountGroupsVariantQuery, SupplierOwnInformationDiscountGroupsVariantQueryVariables>(SupplierOwnInformationDiscountGroupsVariantDocument, options);
      }
export function useSupplierOwnInformationDiscountGroupsVariantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierOwnInformationDiscountGroupsVariantQuery, SupplierOwnInformationDiscountGroupsVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierOwnInformationDiscountGroupsVariantQuery, SupplierOwnInformationDiscountGroupsVariantQueryVariables>(SupplierOwnInformationDiscountGroupsVariantDocument, options);
        }
export function useSupplierOwnInformationDiscountGroupsVariantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierOwnInformationDiscountGroupsVariantQuery, SupplierOwnInformationDiscountGroupsVariantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierOwnInformationDiscountGroupsVariantQuery, SupplierOwnInformationDiscountGroupsVariantQueryVariables>(SupplierOwnInformationDiscountGroupsVariantDocument, options);
        }
export type SupplierOwnInformationDiscountGroupsVariantQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupsVariantQuery>;
export type SupplierOwnInformationDiscountGroupsVariantLazyQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupsVariantLazyQuery>;
export type SupplierOwnInformationDiscountGroupsVariantSuspenseQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupsVariantSuspenseQuery>;
export type SupplierOwnInformationDiscountGroupsVariantQueryResult = Apollo.QueryResult<SupplierOwnInformationDiscountGroupsVariantQuery, SupplierOwnInformationDiscountGroupsVariantQueryVariables>;
export const SupplierOwnInformationDiscountGroupVariantsDocument = gql`
    query SupplierOwnInformationDiscountGroupVariants($limit: Int!, $offset: Int!, $supplierId: ID!) {
  pimSearchSupplierDiscountGroupVariants(
    limit: $limit
    offset: $offset
    filters: {supplierIds: [$supplierId]}
  ) {
    ... on PimSearchSupplierDiscountGroupVariantsResult {
      supplierDiscountGroupVariants {
        id
        title
      }
      totalCount
    }
  }
}
    `;

/**
 * __useSupplierOwnInformationDiscountGroupVariantsQuery__
 *
 * To run a query within a React component, call `useSupplierOwnInformationDiscountGroupVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierOwnInformationDiscountGroupVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierOwnInformationDiscountGroupVariantsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierOwnInformationDiscountGroupVariantsQuery(baseOptions: Apollo.QueryHookOptions<SupplierOwnInformationDiscountGroupVariantsQuery, SupplierOwnInformationDiscountGroupVariantsQueryVariables> & ({ variables: SupplierOwnInformationDiscountGroupVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierOwnInformationDiscountGroupVariantsQuery, SupplierOwnInformationDiscountGroupVariantsQueryVariables>(SupplierOwnInformationDiscountGroupVariantsDocument, options);
      }
export function useSupplierOwnInformationDiscountGroupVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierOwnInformationDiscountGroupVariantsQuery, SupplierOwnInformationDiscountGroupVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierOwnInformationDiscountGroupVariantsQuery, SupplierOwnInformationDiscountGroupVariantsQueryVariables>(SupplierOwnInformationDiscountGroupVariantsDocument, options);
        }
export function useSupplierOwnInformationDiscountGroupVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierOwnInformationDiscountGroupVariantsQuery, SupplierOwnInformationDiscountGroupVariantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierOwnInformationDiscountGroupVariantsQuery, SupplierOwnInformationDiscountGroupVariantsQueryVariables>(SupplierOwnInformationDiscountGroupVariantsDocument, options);
        }
export type SupplierOwnInformationDiscountGroupVariantsQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupVariantsQuery>;
export type SupplierOwnInformationDiscountGroupVariantsLazyQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupVariantsLazyQuery>;
export type SupplierOwnInformationDiscountGroupVariantsSuspenseQueryHookResult = ReturnType<typeof useSupplierOwnInformationDiscountGroupVariantsSuspenseQuery>;
export type SupplierOwnInformationDiscountGroupVariantsQueryResult = Apollo.QueryResult<SupplierOwnInformationDiscountGroupVariantsQuery, SupplierOwnInformationDiscountGroupVariantsQueryVariables>;
export const PimModifySupplierDiscountGroupDocument = gql`
    mutation PimModifySupplierDiscountGroup($input: PimModifySupplierDiscountGroupInput!) {
  pimModifySupplierDiscountGroup(input: $input) {
    discountGroup {
      id
      ...DiscountGroup
    }
  }
}
    ${DiscountGroupFragmentDoc}`;
export type PimModifySupplierDiscountGroupMutationFn = Apollo.MutationFunction<PimModifySupplierDiscountGroupMutation, PimModifySupplierDiscountGroupMutationVariables>;

/**
 * __usePimModifySupplierDiscountGroupMutation__
 *
 * To run a mutation, you first call `usePimModifySupplierDiscountGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePimModifySupplierDiscountGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pimModifySupplierDiscountGroupMutation, { data, loading, error }] = usePimModifySupplierDiscountGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePimModifySupplierDiscountGroupMutation(baseOptions?: Apollo.MutationHookOptions<PimModifySupplierDiscountGroupMutation, PimModifySupplierDiscountGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PimModifySupplierDiscountGroupMutation, PimModifySupplierDiscountGroupMutationVariables>(PimModifySupplierDiscountGroupDocument, options);
      }
export type PimModifySupplierDiscountGroupMutationHookResult = ReturnType<typeof usePimModifySupplierDiscountGroupMutation>;
export type PimModifySupplierDiscountGroupMutationResult = Apollo.MutationResult<PimModifySupplierDiscountGroupMutation>;
export type PimModifySupplierDiscountGroupMutationOptions = Apollo.BaseMutationOptions<PimModifySupplierDiscountGroupMutation, PimModifySupplierDiscountGroupMutationVariables>;